import {isValidPhoneNumber} from "react-phone-number-input";
import {phoneFormatError} from "./environment";
import {find, isEmpty, isUndefined, map, sortBy} from "underscore";

export const addUserOptionLabels = (data, options = {}) => {
  const {shouldSort} = options;
  const shapedUsers = map(data, (each) => {
    const userName = each.fullName || each.nickName;
    return {
      ...each,
      optionLabel: `${userName ? `${userName} ` : ""}(${each.email})`,
    };
  });

  if (shouldSort) {
    return sortBy(shapedUsers, (eachUser) => eachUser?.optionLabel?.toLowerCase());
  }
  return shapedUsers;
};

export const diffUsers = (existingUsers, newUsers) => {
  if (!Array.isArray(existingUsers) || typeof newUsers !== "object") {
    throw Error("Invalid arguments!");
  }
  const existinguserIds = existingUsers.map((userRole) => {
    return userRole.user.id;
  });
  const newuserIds = newUsers.map((newUser) => {
    return newUser.userId;
  });

  return {
    usersToDelete: existinguserIds.filter((existinguserId) => !newuserIds.includes(existinguserId)),
    usersToCreate: newuserIds
      .filter((newuserId) => !existinguserIds.includes(newuserId))
      .map((remaininguserId) => {
        return {userId: remaininguserId};
      }),
  };
};

export const getDisplayName = (user, skipNickname, addEmail = false, skipEmail = false) => {
  if (addEmail) {
    const nameToUse = skipNickname ? user?.fullName : user?.nickname || user.fullName;
    return !isEmpty(nameToUse) ? `${nameToUse} (${user.email})` : user?.email || undefined;
  }
  if (skipNickname) {
    return user?.fullName || (!skipEmail && user?.email) || undefined;
  }
  return user?.nickname || user?.fullName || (!skipEmail && user?.email) || undefined;
};

export const validateAndFormatPhoneForAWS = (phone) => {
  if (!phone || isEmpty(phone)) {
    return {isValid: true, phone: "", error: null};
  }

  let phoneToValidate = phone;

  if (!phone.startsWith("+") && isValidPhoneNumber(phone, "US")) {
    phoneToValidate = "+1" + phone;
  }

  if (!isValidPhoneNumber(phoneToValidate)) {
    return {
      isValid: false,
      phone: null,
      error: phoneFormatError,
    };
  }

  const cleanedPhone = phoneToValidate.replace(/[^\d+]/g, "");
  const isValidFormat = /^\+\d{7,15}$/.test(cleanedPhone);

  if (!isValidFormat) {
    return {
      isValid: false,
      phone: null,
      error: phoneFormatError,
    };
  }

  return {isValid: true, phone: cleanedPhone, error: null};
};

export const getUserSetting = (user, key, defaultValue) => {
  const userSetting = find(user?.settings, (setting) => setting.key === key);
  return userSetting ? userSetting.value : defaultValue;
};

export const getUserSettingBool = (user, key, defaultValue = false) => {
  const value = getUserSetting(user, key);
  if (isUndefined(value)) {
    return defaultValue;
  }
  return value === "true";
};
